<template>
  <div
    style="
      position: absolute;
      left: 600px;
      top: 3px;
      font-size: 1.6em;
      color: #a5292a;
    "
  >
    {{ selectedSliceTitle }}
  </div>
  <div style="display: flex; justify-content: space-between">
    <div
      id="double_pie_chart"
      ref="double_pie_chart"
      style="width: 300px; height: 300px"
    ></div>
    <div class="chart_list">
      <div v-for="(c, k) in legends" :key="k">
        <div class="chart_list_labels">
          <a-badge :color="colorsFixes[c.key]" />
          <!-- <span :style="{color: colorsFixes[c.key]}"> -->
            {{ c.title }}
          <!-- </span> -->
        </div>
        <div class="chart_list_values">
          <span class="a_n"
            ><An :percentFormat="true" :number="c.value"
          /></span>

          <!-- <span class="a_p">({{ c.p }} %)</span> -->
        </div>
      </div>
    </div>

    <div
      id="double_pie_sub_chart"
      ref="double_pie_sub_chart"
      style="width: 240px; height: 240px"
    ></div>
    <div class="chart_list">
      <div v-for="(c, k) in subLegends" :key="k">
        <span v-show="c.value > 0">
          <div class="chart_list_labels">
            <a-badge :color="colors[k]" />
            {{ c.title }}
          </div>
          <div class="chart_list_values">
            <span class="a_n"
              ><An :percentFormat="true" :number="c.value"
            /></span>

            <!-- <span class="a_p">({{ c.p }} %)</span> -->
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import An from "@/components/AnimateNumber.vue";

export default {
  components: { An },
  props: {
    graph_data: {
      type: Object,
      required: true,
    },
    graph_sub_data: {
      type: Object,
      required: true,
    },
    timestamp: {
      type: Number,
      required: true,
    },
    translate_key: {
      type: String,
      required: true,
    },
    translate_sub_key: {
      type: String,
      required: true,
    },
    event_name: {
      type: String,
      required: false,
      default: "updateData_dp",
    },
  },
  watch: {
    timestamp() {
      if (this.evt == null) {
        this.evt = new CustomEvent(this.event_name);
      }
      this.$refs.double_pie_chart.dispatchEvent(this.evt);
    },
  },
  // inject: ["colors"],
  colors:[],
  data() {
    return {
      legends: [],
      subLegends: [],
      selectedSliceTitle: "",
      colorsFixes: {

        a: '#d193ff',
        c: '#00b0f0',
        h: '#ff5a4e',
        o: '#94c356',
        p: '#fcbf21',
        s: '#cc7a00',


        // a: "#008001",
        // c: "#0d00ff",
        // h: "#a52a2a",
        // o: "#fcbf21",
        // p: "#ff0000",
        // s: "#ee82ee",
      }
    };
  },
  methods: {
    createGraph() {
      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);

      am4core.options.autoDispose = true;

      var chart = am4core.create(
        this.$refs.double_pie_chart,
        am4charts.PieChart
      );

      chart.innerRadius = am4core.percent(48);
      chart.language.locale["_thousandSeparator"] = " ";

      Object.entries(this.graph_data.tvals).forEach(([key, val]) => {
        const data = {
          key: key,
          title: this.translate[this.translate_key][key],
          value: val,
          color: this.colorsFixes[key],
        };
        chart.data.push(data);
      });

      Object.entries(this.graph_data.prcts).forEach(([key, val]) => {
        const data = {
          key: key,
          title: this.translate[this.translate_key][key],
          value: val,
        };
        this.legends.push(data);
      });

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "title";
      pieSeries.slices.template.propertyFields.fill = "color";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 1;
      pieSeries.slices.template.strokeOpacity = 1;

      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      // pieSeries.slices.template.alwaysShowTooltip = true;

      pieSeries.slices.template.cursorOverStyle = [
        {
          property: "cursor",
          value: "pointer",
        },
      ];

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;

      pieSeries.tooltip.label.adapter.add("text", function (text, target) {
        if (target.dataItem) {
          return "{title} : {value} €";
        } else {
          return text;
        }
      });

      this.$refs.double_pie_chart.addEventListener(
        this.event_name,
        () => {
          Object.entries(this.graph_data.tvals).forEach(([key, v]) => {
            var index = chart.data.findIndex((s) => s.key == key);

            if (index != undefined) {
              chart.data[index].value = v;
            }
          });

          var inited = false;

          pieSeries.events.on("validated", (ev) => {
            const firstSlice = ev.target.slices.values[0];

            if (!inited) {
              pieSeries.slices.each((item) => {
                item.isActive = false;
              });

              setTimeout(() => {
                firstSlice.isActive = true;
                this.hit(firstSlice.dataItem._dataContext);
              }, 300);
            }

            inited = true;
          });

          this.legends = [];

          Object.entries(this.graph_data.prcts).forEach(([key, val]) => {
            const data = {
              key: key,
              title: this.translate[this.translate_key][key],
              value: val,
            };
            this.legends.push(data);
          });

          chart.invalidateRawData();
        },
        false
      );

      pieSeries.slices.template.events.on("hit", (ev) => {
        var series = ev.target.dataItem.component;
        series.slices.each((item) => {
          if (item == ev.target) {
            this.hit(item.dataItem._dataContext);
          }

          if (item.isActive && item != ev.target) {
            item.isActive = false;
          }
        });
      });

      pieSeries.events.on("datavalidated", (ev) => {
        const firstSlice = ev.target.slices.values[0];
        setTimeout(() => {
          firstSlice.isActive = true;

          this.hit(firstSlice.dataItem._dataContext);
        }, 300);
      });

      // setTimeout(() => {
      //   chart.exporting.getImage("png").then( (imgData) => {
      //     console.log(imgData); // contains exported image data
      //   });
      // }, 1000);
    },
    createSubGraph(selectedKey, color) {
      am4core.options.commercialLicense = true;
      am4core.useTheme(am4themes_animated);

      am4core.options.autoDispose = true;

      var chart = am4core.create(
        this.$refs.double_pie_sub_chart,
        am4charts.PieChart
      );

      chart.innerRadius = am4core.percent(48);
      chart.language.locale["_thousandSeparator"] = " ";

      let count = 0;

      Object.entries(this.graph_sub_data.tvals[selectedKey]).forEach(
        ([key, val]) => {
          const data = {
            key: key,
            title: this.translate[this.translate_sub_key][key],
            value: val,
          };
          chart.data.push(data);
          count++;
        }
      );

      this.subLegends = [];
      Object.entries(this.graph_sub_data.prcts[selectedKey]).forEach(
        ([key, val]) => {
          const data = {
            key: key,
            title: this.translate[this.translate_sub_key][key],
            value: val,
          };
          this.subLegends.push(data);
        }
      );

      // Add and configure Series
      var pieSeries = chart.series.push(new am4charts.PieSeries());
      pieSeries.dataFields.value = "value";
      pieSeries.dataFields.category = "title";
      pieSeries.slices.template.stroke = am4core.color("#fff");
      pieSeries.slices.template.strokeWidth = 1;
      pieSeries.slices.template.strokeOpacity = 1;

      pieSeries.labels.template.disabled = true;
      pieSeries.ticks.template.disabled = true;

      pieSeries.tooltip.label.adapter.add("text", function (text, target) {
        if (target.dataItem) {
          return "{title} : {value} €";
        } else {
          return text;
        }
      });

      this.colors = [];

      const start = 100;
      const end = 10;

      const sequence = this.generateNumberSequence(start, end, count);

      for (let i = 0; i < sequence.length; i++) {
        
        const seq = sequence[i];
        if (seq === 100) {
          pieSeries.colors.list.push(am4core.color(color));
          this.colors.push(color)
        } else {
          pieSeries.colors.list.push(am4core.color(color + seq));
          this.colors.push(color + seq)
        }
      }

      // This creates initial animation
      pieSeries.hiddenState.properties.opacity = 1;
      pieSeries.hiddenState.properties.endAngle = -90;
      pieSeries.hiddenState.properties.startAngle = -90;

      var slice = pieSeries.slices.template;
      slice.states.getKey("hover").properties.scale = 1;
      slice.states.getKey("active").properties.shiftRadius = 0;
    },
    hit(dataContext) {
      this.selectedSliceTitle = dataContext.title;
      this.createSubGraph(dataContext.key, dataContext.color);
    },
    generateNumberSequence(start, end, count) {

      if (count === 1) {
        return [100]
      }
      const step = (end - start) / (count - 1);

      const sequence = [];
      for (let i = 0; i < count; i++) {
        sequence.push(Math.round(start + step * i));
      }

      return sequence;
    },
  },
  computed: {
    translate() {
      return this.$store.getters.translate;
    },
  },
  mounted() {
    setTimeout(() => {
      this.createGraph();
    }, 100);
  },
};
</script>

<style scoped>
.chart_list {
  width: 274px;
  padding-top: 24px;
}
.chart_list_labels {
  display: inline-block;
  vertical-align: top;
  width: 70%;
  padding: 3px;
  white-space: nowrap;
  overflow: hidden;
}
.chart_list_values {
  display: inline-block;
  vertical-align: top;
  width: 20%;
  padding: 3px;
}
</style>